module.exports = __webpack_public_path__ + "static/media/Schiratti1928.fcaa2e0b.jpg";